import sportsTrainingSession from '@/assets/images/sports-training-session.png';
import athleticPerformance from '@/assets/images/athletic-performance.png';
import teamCoaching from '@/assets/images/team-coaching.png';

export default function CoachingSection() {
  const targetAudience = [
    'Freelance coaches',
    'Schools',
    'Club Coaches',
    'Sports Associations',
    'Clubs',
    'Academies',
    'Universities'
  ];

  return (
    <section id="coaching" className="section-wrap bg-black">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <h2 className="section-title leading-tight">
              Designed and developed to make life better for{' '}
              <span className="text-orange-500">everyone involved in coaching.</span>
            </h2>

            <div className="grid grid-cols-2 gap-4">
              {targetAudience.map((audience, index) => (
                <div
                  key={index}
                  className="text-gray-300 text-lg font-medium hover:text-orange-500 transition-colors duration-300 cursor-pointer"
                >
                  {audience}
                </div>
              ))}
            </div>

            <button className="group bg-orange-500 hover:bg-orange-600 text-black font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              <span className="relative z-10">Read more about us</span>
            </button>
          </div>

          {/* Right Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img
                  src={sportsTrainingSession}
                  alt="Sports training session"
                  loading="lazy"
                  className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                />
                <img
                  src={athleticPerformance}
                  alt="Athletic performance"
                  loading="lazy"
                  className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                />
              </div>
              <div className="pt-8">
                <img
                  src={teamCoaching}
                  alt="Team coaching"
                  loading="lazy"
                  className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}